export default __webpack_public_path__ + "media/images/bg-95373e78781d43a00293fe50ddea8fa2.jpg";